import React from "react";
import { createPortal } from "react-dom";
import deleteButtonIcon from "../media/delete-button.svg";

/**
 * Generic delete confirmation dialog component
 *
 * @param {boolean} isOpen - Controls whether the dialog is visible
 * @param {function} onClose - Callback when dialog is closed/cancelled
 * @param {function} onConfirm - Callback when delete is confirmed
 * @param {string} message - Optional custom message (defaults to "Czy na pewno chcesz usunąć ten zasób?")
 * @param {React.ReactNode} children - Optional additional content to display in the dialog
 */
const DeleteConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  message = "Czy na pewno chcesz usunąć ten zasób?",
  children,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div className="confirmation-overlay" onClick={handleOverlayClick}>
      <div className="confirmation-box" onClick={(e) => e.stopPropagation()}>
        <img
          className="close-button"
          src={deleteButtonIcon}
          alt="Close"
          onClick={onClose}
        />
        <div className="areYouSure">
          <p>{message}</p>
          {children && <div className="reservation-details">{children}</div>}
        </div>
        <div className="confirmation-buttons">
          <button onClick={onConfirm}>TAK</button>
          <button onClick={onClose}>NIE</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmationDialog;
